import React, { ComponentProps } from 'react';
import IForm from '../../../types/IForm';
import { useAppContext } from '../../../contexts/AppContext/AppContext';
import { PostsList, PostFirst, PostWithReplies } from '../../../_lib/components/Posts';
import { asView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { CommentsMainEditor } from '../partials/CommentsMainEditor';

type DefaultViewProps = { createForm: IForm; posts: PostFirst[]; commentsActive: true } | { commentsActive: false };

function CommentsDefault(props: DefaultViewProps) {
  const { t } = useSonTranslation('CommentsBlock');
  const {
    userInfo,
    editModeInfo: { active },
  } = useAppContext();

  if (!props.commentsActive) {
    return active
      ? (
          <div className="posts__activation-info">
            <p>{t('default.disabled')}</p>
          </div>
        )
      : null;
  }

  const { createForm, posts } = props;
  // if edit mode is active and we have no comments, we do not want to show anything
  if (active && (!posts || posts.length === 0)) {
    return (
      <div className="posts__activation-info">
        <p>{t('default.enabled')}</p>
      </div>
    );
  }

  /**
   * Heading hierachys
   */
  const headingHierarchy = 2;
  const subHeadingsHierarchy = headingHierarchy + 1;
  const commentHeadingsHierarchy = subHeadingsHierarchy + 1;

  /**
   * different dafault view in edit mode to inform user of activation
   * no information if disabled
   * */
  return (
    <div className="posts posts--comments">
      {!active && userInfo?.loggedIn && (
        <CommentsMainEditor subHeadingsHierarchy={subHeadingsHierarchy} createForm={createForm} />
      )}
      <PostsList headingHierarchy={subHeadingsHierarchy} type="comment">
        {posts.map((comment, index) => {
          return (
            <PostWithReplies
              key={comment.id}
              post={comment}
              index={index}
              headingHierarchy={commentHeadingsHierarchy}
              previousPostId={index > 0 ? posts[index - 1].id : undefined}
              type="comment"
            />
          );
        })}
      </PostsList>
    </div>
  );
}

export const CommentsDefaultView = asView(CommentsDefault);
export type CommentsDefaultView = ComponentProps<typeof CommentsDefaultView>;
